import { httpService } from '@/api/v1/http.service'
import useMutationWithErrorsHandling from '@/hooks/useMutationWithErrorsHandling'
import { formatApiDate } from '@/utils/format-date'

type ScheduleArchivePayload = {
  ids: string[]
  archiveDate?: Date
}
const useBulkScheduleArchiveStudents = ({
  onSuccess,
  onError
}: {
  onSuccess: (data: {
    successfully_scheduled: number
    unsuccessfully_scheduled: number
    cancelled_schedule: number
    archiveDate?: Date
  }) => void
  onError: (payload: ScheduleArchivePayload) => void
}) =>
  useMutationWithErrorsHandling({
    mutationFn: (data: ScheduleArchivePayload) =>
      httpService.panel.panelStudentsScheduleArchiveCreate({
        students_ids: data.ids,
        archive_date: data.archiveDate
          ? formatApiDate(new Date(data.archiveDate))
          : null
      }),
    onSuccess: (response, variables) =>
      onSuccess?.({
        ...response,
        archiveDate: variables.archiveDate
      }),
    onError: (_, variables) => onError?.(variables)
  })

export default useBulkScheduleArchiveStudents
